import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "../site/motion";
import OrbitVisual from "../site/OrbitVisual";

export default function AboutPreview() {
  return (
    <section id="about" data-testid="about-section" className="bg-white py-24 md:py-32">
      <div className="mx-auto grid w-full max-w-[1200px] items-center gap-16 px-6 md:px-8 lg:grid-cols-2">
        <Reveal className="order-2 lg:order-1">
          <OrbitVisual />
        </Reveal>
        <Reveal delay={1} className="order-1 lg:order-2">
          <Eyebrow>About Bytevora</Eyebrow>
          <h2 className="mt-5 text-3xl font-bold leading-[1.08] tracking-[-0.02em] text-slate-900 md:text-[2.6rem]">
            Technology built with purpose.
          </h2>
          <p className="mt-5 max-w-lg text-sm leading-relaxed text-slate-600 md:text-base">
            Bytevora is a technology company focused on designing, engineering, and scaling
            modern software, digital products, cloud platforms, and intelligent systems.
          </p>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-slate-600 md:text-base">
            We combine product thinking, practical engineering, and modern technology to help
            businesses build solutions that work today and remain ready for what comes next.
          </p>
          <Link
            to="/about"
            data-testid="about-preview-link"
            className="group mt-8 inline-flex items-center gap-2 text-sm font-semibold text-slate-900 transition-colors duration-300 hover:text-blue-600"
          >
            About Bytevora
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
